/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import {
  Boxed,
  Close,
  Detached,
  Horizontal,
  Two_col,
  Veritical,
  compact,
  dark,
  small_hover,
} from "../Routes/ImagePath";
import { Link } from "react-router-dom";
import { setLayout } from "../user";
import { useDispatch } from "react-redux";

const OffCanvas = () => {
  const dispatch = useDispatch();
  const [showSettingsIcon, setShowSettingsIcon] = useState(false);
  const [layoutStyle, setLayoutStyle] = useState(localStorage.getItem("layout"));
  const [layoutColor, setlayoutColor] = useState(localStorage.getItem("colorschema"));
  const [layoutWidths, setLayoutwidths] = useState(localStorage.getItem("layoutpos"));
  const [layoutPosition, setLayoutposition] = useState(localStorage.getItem("layoutwidth"));
  const [layoutTopbar, setLayoutTopbar] = useState(localStorage.getItem("topbartheme"));
  const [layoutSize, setLayoutSize] = useState(localStorage.getItem("layoutSized"));
  const [layoutView, setLayoutView] = useState(localStorage.getItem("layoutStyling"));
  const [layoutSidebar, setLayoutSidebar] = useState(localStorage.getItem("layoutSidebarStyle"));

  function refreshPage() {
    window.location.reload(false);
  }

  const setThemes = () => {
    const getlayout = localStorage.getItem("layout");
    if (getlayout === "horizontal") changes();
    else if (getlayout === "vertical") Vertical();
    else TwoColumn();
  };

  const setColorSchema = (color) => {
    switch (color) {
      case "orange":
        OrangeThemes();
        break;
      case "dark":
        DarkThemes();
        break;
      case "light":
        LightThemes();
        break;
      case "blue":
        BlueThemes();
        break;
      default:
        MaroonThemes();
    }
  };

  const setLayoutWidth = () => {
    const getlayoutWidth = localStorage.getItem("layoutwidth");
    if (getlayoutWidth === "scrollable") ScrollBar();
    else Fixed();
  };

  const setLayoutpos = () => {
    const getlayoutPos = localStorage.getItem("layoutpos");
    if (getlayoutPos === "boxed") BoxThemes();
    else Fluid();
  };

  const setLayoutBars = () => {
    const gettopBar = localStorage.getItem("topbartheme");
    if (gettopBar === "light") LightBarThemes();
    else DarkBarThemes();
  };

  const setSizes = () => {
    const getlayoutSize = localStorage.getItem("layoutSized");
    if (getlayoutSize === "lg") Default();
    else if (getlayoutSize === "md") Compact();
    else SmallHoverView();
  };

  const setlayoutStyling = () => {
    const getlayoutStyle = localStorage.getItem("layoutStyling");
    if (getlayoutStyle === "default") DefaultStyle();
    else DetachedStyle();
  };

  const setLayoutSidebarStyling = () => {
    const getlayoutSidebar = localStorage.getItem("layoutSidebarStyle");
    if (getlayoutSidebar === "light") LightStyle();
    else if (getlayoutSidebar === "dark") DarkStyle();
    else GradientStyle();
  };

  useEffect(() => {
    setThemes();
    setColorSchema(localStorage.getItem("colorschema"));
    setLayoutWidth();
    setLayoutpos();
    setLayoutBars();
    setSizes();
    setlayoutStyling();
    setLayoutSidebarStyling();
    Default();
  }, []);

  const changes = () => {
    dispatch(setLayout("horizontal"));
    localStorage.setItem("layout", "horizontal");
    const Themes = document.querySelector("html");
    const horizantalSidebar = document.querySelector("#horizantal-sidebar");
    const veriticalSidebar = document.querySelector("#veritical-sidebar");
    const twoColBar = document.querySelector(".two-col-bar");
    const sidebar = document.querySelector(".sidebar");

    if (Themes) Themes.setAttribute("data-layout", "horizontal");
    if (horizantalSidebar) horizantalSidebar.style.display = "block";
    if (veriticalSidebar) veriticalSidebar.style.display = "none";
    if (twoColBar) twoColBar.style.display = "none";
    if (sidebar) sidebar.classList.remove("sidebar-verticalset");
  };

  const Vertical = () => {
    dispatch(setLayout("vertical"));
    localStorage.setItem("layout", "vertical");
    const VeriticalLayout = document.querySelector("html");
    const horizantalSidebar = document.querySelector("#horizantal-sidebar");
    const veriticalSidebar = document.querySelector("#veritical-sidebar");
    const twoColBar = document.querySelector(".two-col-bar");
    const sidebar = document.querySelector("#sidebar");

    if (VeriticalLayout) VeriticalLayout.setAttribute("data-layout", "vertical");
    if (horizantalSidebar) horizantalSidebar.style.display = "none";
    if (veriticalSidebar) veriticalSidebar.style.display = "block";
    if (twoColBar) twoColBar.style.display = "none";
    if (sidebar) sidebar.classList.add("sidebar-verticalset");
  };

  const TwoColumn = () => {
    localStorage.setItem("layout", "twocolumn");
    const TwoColumnLayout = document.querySelector("html");
    const horizantalSidebar = document.querySelector("#horizantal-sidebar");
    const veriticalSidebar = document.querySelector("#veritical-sidebar");
    const twoColBar = document.querySelector(".two-col-bar");

    if (TwoColumnLayout) TwoColumnLayout.setAttribute("data-layout", "");
    if (horizantalSidebar) horizantalSidebar.style.display = "none";
    if (veriticalSidebar) veriticalSidebar.style.display = "none";
    if (twoColBar) twoColBar.style.display = "block";
  };

  const OrangeThemes = () => {
    localStorage.setItem("colorschema", "orange");
    const OrangesThemes = document.querySelector("html");
    if (OrangesThemes) OrangesThemes.setAttribute("data-layout-mode", "orange");
  };

  const DarkThemes = () => {
    localStorage.setItem("colorschema", "dark");
    localStorage.setItem("topbartheme", "dark");
    const DarksThemes = document.querySelector("html");
    if (DarksThemes) {
      DarksThemes.setAttribute("data-layout-mode", "dark");
      DarksThemes.setAttribute("data-topbar", "dark");
    }
  };

  const LightThemes = () => {
    localStorage.setItem("colorschema", "light");
    const LightsThemes = document.querySelector("html");
    if (LightsThemes) LightsThemes.setAttribute("data-layout-mode", "light");
  };

  const BlueThemes = () => {
    localStorage.setItem("colorschema", "blue");
    const BluesThemes = document.querySelector("html");
    if (BluesThemes) {
      BluesThemes.setAttribute("data-layout-mode", "blue");
      BluesThemes.setAttribute("data-topbar", "blue");
    }
  };

  const MaroonThemes = () => {
    localStorage.setItem("colorschema", "maroon");
    const MaroonsThemes = document.querySelector("html");
    if (MaroonsThemes) {
      MaroonsThemes.setAttribute("data-layout-mode", "maroon");
      MaroonsThemes.setAttribute("data-topbar", "maroon");
    }
  };

  const ScrollBar = () => {
    localStorage.setItem("layoutwidth", "scrollable");
    const ScrollBarThemes = document.querySelector("html");
    if (ScrollBarThemes) ScrollBarThemes.setAttribute("data-layout-position", "scrollable");
  };

  const Fixed = () => {
    localStorage.setItem("layoutwidth", "fixed");
    const FixedThemes = document.querySelector("html");
    if (FixedThemes) FixedThemes.setAttribute("data-layout-position", "fixed");
  };

  const PurpleThemes = () => {
    localStorage.setItem("colorschema", "purple");
    const PurplesThemes = document.querySelector("html");
    if (PurplesThemes) {
      PurplesThemes.setAttribute("data-layout-mode", "purple");
      PurplesThemes.setAttribute("data-topbar", "purple");
    }
  };

  const LightBarThemes = () => {
    localStorage.setItem("topbartheme", "light");
    const LightBarsThemes = document.querySelector("html");
    if (LightBarsThemes) {
      LightBarsThemes.setAttribute("data-topbar", "light");
      LightBarsThemes.setAttribute("data-sidebar", "dark");
    }
  };

  const DarkBarThemes = () => {
    localStorage.setItem("topbartheme", "dark");
    const DarkBarsThemes = document.querySelector("html");
    if (DarkBarsThemes) {
      DarkBarsThemes.setAttribute("data-topbar", "dark");
      DarkBarsThemes.setAttribute("data-sidebar", "light");
    }
  };

  const Fluid = () => {
    localStorage.setItem("layoutpos", "fluid");
    const FluidThemes = document.querySelector("html");
    if (FluidThemes) {
      FluidThemes.setAttribute("data-layout-width", "fluid");
      FluidThemes.setAttribute("data-sidebar-size", "lg");
    }
  };

  const BoxThemes = () => {
    localStorage.setItem("layoutpos", "boxed");
    const BoxsThemes = document.querySelector("html");
    if (BoxsThemes) {
      BoxsThemes.setAttribute("data-layout-width", "boxed");
      BoxsThemes.setAttribute("data-sidebar-size", "sm-hover");
    }
  };

  const Default = () => {
    localStorage.setItem("layoutSized", "lg");
    const DefaultThemes = document.querySelector("html");
    if (DefaultThemes) DefaultThemes.setAttribute("data-sidebar-size", "lg");
  };

  const Compact = () => {
    localStorage.setItem("layoutSized", "md");
    const CompactThemes = document.querySelector("html");
    if (CompactThemes) CompactThemes.setAttribute("data-sidebar-size", "md");
  };

  const SmallHoverView = () => {
    localStorage.setItem("layoutSized", "sm-hover");
    const SmallHoverViewThemes = document.querySelector("html");
    if (SmallHoverViewThemes) SmallHoverViewThemes.setAttribute("data-sidebar-size", "sm-hover");
  };

  const DefaultStyle = () => {
    localStorage.setItem("layoutStyling", "default");
    const DefaultStylesThemes = document.querySelector("html");
    if (DefaultStylesThemes) DefaultStylesThemes.setAttribute("data-layout-style", "default");
  };

  const DetachedStyle = () => {
    localStorage.setItem("layoutStyling", "detached");
    const DetachedStylesThemes = document.querySelector("html");
    if (DetachedStylesThemes) DetachedStylesThemes.setAttribute("data-layout-style", "detached");
  };

  const LightStyle = () => {
    localStorage.setItem("layoutSidebarStyle", "light");
    const htmlElement = document.querySelector("html");
    if (htmlElement) htmlElement.setAttribute("data-sidebar", "light");
  };

  const DarkStyle = () => {
    localStorage.setItem("layoutSidebarStyle", "dark");
    const DarkStylesThemes = document.querySelector("html");
    if (DarkStylesThemes) DarkStylesThemes.setAttribute("data-sidebar", "dark");
  };

  const GradientStyle = () => {
    localStorage.setItem("layoutSidebarStyle", "gradient");
    const GradientsThemes = document.querySelector("html");
    if (GradientsThemes) GradientsThemes.setAttribute("data-sidebar", "gradient");
  };

  const resetFunctions = () => {
    localStorage.setItem("colorschema", "orange");
    const OrangesThemes = document.querySelector("html");
    if (OrangesThemes) OrangesThemes.setAttribute("data-layout-mode", "orange");
    localStorage.setItem("layout", "vertical");
    const VeriticalLayout = document.querySelector("html");
    const horizantalSidebar = document.querySelector("#horizantal-sidebar");
    const veriticalSidebar = document.querySelector("#veritical-sidebar");
    const twoColBar = document.querySelector(".two-col-bar");
    const sidebar = document.querySelector("#sidebar");

    if (VeriticalLayout) VeriticalLayout.setAttribute("data-layout", "vertical");
    if (horizantalSidebar) horizantalSidebar.style.display = "none";
    if (veriticalSidebar) veriticalSidebar.style.display = "block";
    if (twoColBar) twoColBar.style.display = "none";
    if (sidebar) sidebar.classList.add("sidebar-verticalset");
    const FluidThemes = document.querySelector("html");
    if (FluidThemes) {
      FluidThemes.setAttribute("data-layout-width", "fluid");
      FluidThemes.setAttribute("data-sidebar-size", "lg");
    }
    localStorage.setItem("topbartheme", "light");
    const LightBarsThemes = document.querySelector("html");
    if (LightBarsThemes) {
      LightBarsThemes.setAttribute("data-topbar", "light");
      LightBarsThemes.setAttribute("data-sidebar", "dark");
    }
    localStorage.setItem("layoutStyling", "default");
    const DefaultStylesThemes = document.querySelector("html");
    if (DefaultStylesThemes) DefaultStylesThemes.setAttribute("data-layout-style", "default");
    setLayoutStyle("vertical");
    setlayoutColor("orange");
    setLayoutwidths("fluid");
    setLayoutposition("fixed");
    setLayoutTopbar("light");
    setLayoutSize("default");
    setLayoutView("default");
    setLayoutSidebar("dark");
    localStorage.setItem("layoutwidth", "fixed");
    localStorage.setItem("layoutpos", "fluid");
    localStorage.setItem("layoutSized", "lg");
    localStorage.setItem("layoutStyling", "default");
    localStorage.setItem("layoutSidebarStyle", "dark");
  };

  return (
    <>
      <div>
        {showSettingsIcon && (
          <div className="settings-icon">
            <span
              data-bs-toggle="offcanvas"
              data-bs-target="#theme-settings-offcanvas"
              aria-controls="theme-settings-offcanvas"
            >
              <i className="las la-cog" />
            </span>
          </div>
        )}
        <div
          className="offcanvas offcanvas-end border-0"
          tabIndex={-1}
          id="theme-settings-offcanvas"
        >
          <div className="sidebar-headerset">
            <div className="sidebar-headersets">
              <h2>Customizer</h2>
              <h3>Customize your overview Page layout</h3>
            </div>
            <div className="sidebar-headerclose">
              <Link to="#" data-bs-dismiss="offcanvas" aria-label="Close">
                <img src={Close} alt="img" />
              </Link>
            </div>
          </div>
          <div className="offcanvas-body p-0">
            <div data-simplebar className="h-100">
              <div className="settings-mains">
                <div className="layout-head">
                  <h5>Layout</h5>
                  <h6>Choose your layout</h6>
                </div>
                <div className="row">
                  <div className="col-4">
                    <div className="form-check card-radio p-0">
                      <input
                        id="customizer-layout01"
                        name="data-layout"
                        type="radio"
                        defaultValue="vertical"
                        checked={layoutStyle === "vertical" ? true : false}
                        onChange={() => setLayoutStyle("vertical")}
                        className="form-check-input"
                      />
                      <label
                        className="form-check-label avatar-md w-100"
                        htmlFor="customizer-layout01"
                      >
                        <img src={Veritical} alt="img" onClick={Vertical} />
                      </label>
                    </div>
                    <h5 className="fs-13 text-center mt-2">Vertical</h5>
                  </div>
                  <div className="col-4">
                    <div className="form-check card-radio p-0">
                      <input
                        id="customizer-layout02"
                        name="data-layout"
                        type="radio"
                        defaultValue="horizontal"
                        checked={layoutStyle === "horizontal" ? true : false}
                        onChange={() => setLayoutStyle("horizontal")}
                        className="form-check-input"
                      />
                      <label
                        className="form-check-label avatar-md w-100"
                        htmlFor="customizer-layout02"
                      >
                        <img
                          src={Horizontal}
                          alt="img"
                          onClick={changes}
                          onChange={refreshPage}
                        />
                      </label>
                    </div>
                    <h5 className="fs-13 text-center mt-2">Horizontal</h5>
                  </div>
                  <div className="col-4">
                    <div className="form-check card-radio p-0">
                      <input
                        id="customizer-layout03"
                        name="data-layout"
                        type="radio"
                        defaultValue="twocolumn"
                        checked={layoutStyle === "twocolumn" ? true : false}
                        onChange={() => setLayoutStyle("twocolumn")}
                        className="form-check-input"
                      />
                      <label
                        className="form-check-label avatar-md w-100"
                        htmlFor="customizer-layout03"
                      >
                        <img src={Two_col} alt="img" onClick={TwoColumn} />
                      </label>
                    </div>
                    <h5 className="fs-13 text-center mt-2">Two Column</h5>
                  </div>
                </div>
                {/* Rest of the JSX remains unchanged for brevity */}
                {/* Add other sections (Color Scheme, Layout Width, etc.) back if needed */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OffCanvas;